module.exports = __webpack_public_path__ + "static/media/moneybox.9fe3046a.png";